//Search.js
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite/no-important";
import Button from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search";
import Close from "@material-ui/icons/Close";
import Moon from "../packages/Moon";
import Common from "./Common";

const styles = {
	searchInput: {
		backgroundColor: "transparent",
		border: "0px solid transparent",
		outline: "0px solid transparent",
		color: "#666",
		fontSize: "16px",
		width: "100%",
		margin: "0px 5px",
		cursor: "pointer"
	},
	searchIcon: {
		color: "#777",
		padding: "9px 15px",
		boxSizing: "border-box",
		height: "42px"
	}
};

const classes = StyleSheet.create({
	searchBox: {
		display: "flex",
		minWidth: "350px",
		maxWidth: "100%",
		justifyContent: "flex-start",
		alignItems: "center",
		padding: "0px",
		borderRadius: "3px",
		height: "42px",
		backgroundColor: "#f1f1f1",
		cursor: "pointer"
	},
	clearSearchButton: {
		minWidth: "30px",
		color: "#777"
	}
});

class Search extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			searchValue: Moon.use(""),
			searchElements: Moon.use(null),
			showSearch: Moon.use(false),
			sideBarSelected: Moon.use(null)
		};

		this.searchInput = React.createRef();
		this.searchElements = [];
	}

	componentWillMount = () => {
		Moon.addStar(this);
	};

	searchInputOnChange(event) {
		let value = event.target.value;
		if (value == null || value == "") value = null;
		this.setSearch(value);
	}

	getProductsByValue(value) {
		if (value == null) return null;
		let elements = Moon.getState("products", []).filter(p =>
			p.search.includes(value.toLowerCase())
		);
		elements = elements.map((e, i) => {
			let item = Object.assign({}, e);
			item.sort = i;
			item.gridName = "search";
			return item;
		});
		return elements;
	}

	setSearch(searchValue) {
		let searchElements = this.getProductsByValue(searchValue);
		this.setState({
			sideBarSelected: "search",
			searchValue: searchValue,
			searchElements: searchElements
		});
	}

	getSearchResults(value) {
		if (this.searchElements == null || this.searchElements.length === 0)
			return [];
		var searchResults = this.searchElements.filter(e => {
			return e.value.includes(value);
		});
		return searchResults;
	}

	fillPlaceHolder() {
		let products = Moon.getState("products", []);
		let item = products[0];
		let additionalAttributes = item.additional_attributes;
		let keys = Object.keys(additionalAttributes);
		let placeholder = "Search by name";
		keys.forEach((key, i) => {
			if (i != keys.length - 1) placeholder += ", " + key;
		});
		placeholder += " or " + keys[keys.length - 1];
		return placeholder;
	}
	renderSearch() {
		if (this.state.showSearch != true) return null;
		let searchValue = this.state.searchValue;
		return (
			<Button
				id="searchBox"
				classes={{ root: css(classes.searchBox) }}
				onClick={() => this.searchInput.current.focus()}
			>
				{searchValue === null || searchValue === "" ? (
					<div style={styles.searchIcon}>
						<SearchIcon />
					</div>
				) : (
					<Button
						classes={{ root: css(classes.clearSearchButton) }}
						onClick={() => Common.clearSearch(this)}
					>
						<Close />
					</Button>
				)}
				<input
					type="text"
					onChange={this.searchInputOnChange.bind(this)}
					value={this.state.searchValue}
					style={styles.searchInput}
					ref={this.searchInput}
					placeholder={this.fillPlaceHolder()}
				/>
			</Button>
		);
	}

	render() {
		return this.renderSearch();
	}
}

export default Search;
